import React, { ReactNode } from 'react';
import { cn } from '../cn';
import { labelClasses, inputClasses } from '../recipes/input';
import { Label } from './Label';

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...attrs }, ref) => (
  <input ref={ref} className={cn(inputClasses, className)} {...attrs} />
));

Input.displayName = 'Input';

export function FormField({
  label,
  htmlFor,
  error,
  children,
  className,
}: {
  label: ReactNode;
  htmlFor?: string;
  error?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <Label htmlFor={htmlFor}>{label}</Label>
      <div className="mt-1">{children}</div>
      {error}
    </div>
  );
}

export { labelClasses, inputClasses };
